import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { transformPublicationsResponse, transformPublicationDetailsResponse, } from '../apiResponseTransformers/publications';
export const publicationType = {
    ownersManual: 'OwnersManual',
    navigationManual: 'NavigationManual',
    quickStartGuide: 'QuickStartGuide',
    warrantyMaintenanceGuide: 'WarrantyMaintenanceGuide',
};
const publicationsApi = createApi({
    reducerPath: 'publicationsApi',
    baseQuery: fetchBaseQuery(),
    endpoints: builder => ({
        getManualsPublications: builder.query({
            query: ({ url, headers }) => ({
                url,
                headers,
            }),
            transformResponse: transformPublicationsResponse,
        }),
        getManualDetails: builder.query({
            query: ({ url, headers, queryParams }) => ({ url, headers, params: queryParams }),
            transformResponse: transformPublicationDetailsResponse,
        }),
    }),
});
export const publicationsApiReducer = publicationsApi.reducer;
export const publicationsApiMiddleware = publicationsApi.middleware;
export default publicationsApi;
export const { useGetManualsPublicationsQuery, useGetManualDetailsQuery } = publicationsApi;
